import axios from "../../axios";
import { API_V3 } from "../../constants";
import i18n from "../../i18n";
import * as actionTypes from "./actionTypes";

export const setCity = (data) => {
  return {
    type: actionTypes.SET_CITY,
    cities: data,
  };
};

export const setCityLoading = () => {
  return {
    type: actionTypes.FETCH_CITY_STARTING,
  };
};

export const fetchCityFailed = () => {
  return {
    type: actionTypes.FETCH_CITY_FAILED,
  };
};

export const getCity = (lang = i18n.language) => {
  return (dispatch) => {
    // ${moment().format('YYYY/MM')}
    dispatch(setCityLoading());
    axios
      .get(`${API_V3}${lang}/cities?limit=9999`)
      .then((response) => {
        dispatch(
          setCity(
            response.data.cities.sort((a, b) => {
              if (a.name < b.name) return -1;
              if (a.name > b.name) return 1;
              return 0;
            })
          )
        );
      })
      .catch((error) => {
        console.log("err", error);
        dispatch(fetchCityFailed());
      });
  };
};
export const setStorages = (data) => {
  return {
    type: actionTypes.SET_STORAGES,
    storages: data,
  };
};

export const setStoragesLoading = () => {
  return {
    type: actionTypes.FETCH_STORAGES_STARTING,
  };
};

export const fetchStoragesFailed = () => {
  return {
    type: actionTypes.FETCH_STORAGES_FAILED,
  };
};
export const getStorages = (cityId, lang = i18n.language) => {
  return (dispatch) => {
    dispatch(setStoragesLoading());
    axios
      .get(`${API_V3}${lang}/city/${cityId}?limit=9999`)
      .then((response) => {
        dispatch(setStorages(response.data));
      })
      .catch((error) => {
        console.log("err", error);
        dispatch(fetchStoragesFailed());
      });
  };
};
